var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi-form-menu"},[_c('HorizontalMenu',{attrs:{"items":_vm.menuItems,"value":_vm.selectedIndex,"size":"small","hideLines":""},on:{"onChange":_vm.handleOnChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }